import { Box, Divider, SystemIcon, Typography } from '@wishket/design-system';

import EmptyContent from '../EmptyContent';

import { EmploymentListItem } from './parts';

import { Link } from '@/shared/Components';
import { AuthorEmployment } from '@/shared/types';
import { PATH } from '@/shared/constants';

interface AuthorIntroductionProps {
  description?: string;
  employments?: AuthorEmployment[];
  linkUrl?: string;
  isOwner?: boolean;
  urlIdentifier?: string;
}

const AuthorIntroduction = ({
  description,
  employments,
  linkUrl,
  isOwner,
  urlIdentifier,
}: AuthorIntroductionProps) => {
  if (!description) {
    const emptyContentProps = isOwner
      ? {
          title: '등록된 소개가 없어요.',
          description: '작가님을 알리고, 콘텐츠 신뢰도를 높여보세요!',
          linkButtonName: '소개 입력하기',
          linkButtonUrl: `${PATH.HOME}/@${urlIdentifier}/profiles`,
        }
      : { title: '등록된 소개가 없어요.' };

    return <EmptyContent {...emptyContentProps} />;
  }

  return (
    <Box
      className="flex flex-col gap-10 desktop:gap-12"
      data-testid="feature--author-introduction"
    >
      <Box
        className="flex flex-col gap-8"
        data-testid="author-introduction--description"
      >
        <Typography variant="subTitle1" className="font-medium text-w-gray-900">
          소개
        </Typography>
        <Typography
          variant="contents2"
          className="whitespace-pre-line text-w-gray-600"
        >
          {description}
        </Typography>
      </Box>
      {employments && employments.length > 0 && (
        <>
          <Divider />
          <Box
            className="flex flex-col gap-8"
            data-testid="author-introduction--employment-list"
          >
            <Typography
              variant="subTitle1"
              className="font-medium text-w-gray-900"
            >
              경력
            </Typography>
            <Box className="flex flex-col gap-4 text-primary">
              {employments.map((item) => (
                <EmploymentListItem
                  key={item.id}
                  isFreelancer={item.isFreelancer}
                  companyName={item.companyName}
                  workingCompanyName={item.workingCompanyName}
                  clientName={item.clientName}
                />
              ))}
            </Box>
          </Box>
        </>
      )}
      {linkUrl && (
        <>
          <Divider />
          <Box
            className="flex flex-col gap-8"
            data-testid="author-introduction--link"
          >
            <Typography
              variant="subTitle1"
              className="font-medium text-w-gray-900"
            >
              링크
            </Typography>
            <Link
              href={linkUrl}
              className="flex size-[50px] w-fit items-center justify-center rounded-xl border px-3"
              target="_blank"
              data-testid="author-introduction--link-button"
            >
              <SystemIcon name="large_link" />
            </Link>
          </Box>
        </>
      )}
    </Box>
  );
};

export default AuthorIntroduction;
